import { Injectable } from "@angular/core";
import { environment } from '@env/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class Encrypt {

  encryptData(data: any) {

    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), environment.secretKey).toString();
    } catch (e) {
      //console.error(e);
      return '';
    }
  }

  decryptData(data:any) {
    try {
      const bytes = CryptoJS.AES.decrypt(data, environment.secretKey);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return false;
    } catch (e) {
      //console.error(e);
      return '';
    }
  }

  public cryptDataIV(value: any) {

    const keyEncr = CryptoJS.enc.Hex.parse(environment.secretKey);
    const iv = CryptoJS.enc.Hex.parse(environment.secretIv);
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), keyEncr, { iv: iv }).toString().replace(/\+/gi, "-").replace(/\//gi, "_");

    return encrypted;
  }


  decryptDataIV(data:any) {

    try {
      // Ej:const prueba = this.utils.decryptDataIV("Vq/S8UNSoc2ny5dRrTYsXQ==");
      const keyEncr = CryptoJS.enc.Hex.parse(environment.secretKey);
      const iv = CryptoJS.enc.Hex.parse(environment.secretIv);

      data = data.replace(/-/gi, "+");
      data = data.replace(/_/gi, "/");
      data = data.replace(/%3D/gi, "=");

      const decrypted = CryptoJS.AES.decrypt(data, keyEncr, { iv: iv })

      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      // console.log('error');
      return '';
    }
  }


}
